import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const Card = styled.div`
  border: "0";
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.9rem;
  color: black;
  background: white;
  width: "100%";
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0px;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.3rem;
`;
const CardTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
`;
const CardNumber = styled.div`
  font-size: 1.3rem;
  font-weight: 700;
`;

const CardSubTitle = styled.button`
  background-color: white;
  border: 0px;
  font-size: 1.3rem;
  padding-bottom: 0.3rem;
  font-weight: 400;
  color: ${(props) => (props.greenColor ? "#3eb462" : "#e50000")};
`;
const Data = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  opacity: 0.8;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const GraphicContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const GraphicName = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: -0.3rem;
  opacity: 0.9;
`;
const DataTitle = styled.div`
  //margin-top: 0.9rem;
  font-size: 0.9rem;
  font-weight: 400;
  opacity: 0.8;
  font-style: italic;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.9rem;
`;
const SwitchButton = styled.div`
  //background-color: rgba(0, 0, 0, 0.04);
  margin: -1.1rem -0.5rem 0rem;
  border: 0px;
  font-size: 1.3rem;
  font-weight: 700;
`;

function CustomCardCharts(props) {
  return (
    <div>
      <Card>
        <TitleContainer>
          <CardTitle>{props.cardTitle2}</CardTitle>
          <SwitchButton>{props.switchButton}</SwitchButton>
        </TitleContainer>
        <TitleContainer>
          <CardTitle>{props.cardTitle}</CardTitle>
          <CardNumber>{props?.cardNumber}</CardNumber>
        </TitleContainer>
        <DataList>
          <DataContainer>
            <Data>{props.dataName0}</Data>
            <Data>{props.data0result}</Data>
          </DataContainer>
        </DataList>

        <TitleContainer>
          <DataTitle>{props.dataTitle}</DataTitle>
        </TitleContainer>
        <TitleContainer>
          {props.cardResultGreen && (
            <CardSubTitle greenColor>
              <ArrowUpwardIcon /> {props.cardResultGreen}
            </CardSubTitle>
          )}
          {props.cardResultRed && (
            <CardSubTitle>
              <ArrowDownwardIcon /> {props.cardResultRed}
            </CardSubTitle>
          )}
        </TitleContainer>

        <DataList>
          <DataContainer>
            <Data>{props.dataName1}</Data>
            <Data>{props?.data1result || ""}</Data>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName2}</Data>
            <Data>{props?.data2result}</Data>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName3}</Data>
            <Data>{props.data3result}</Data>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName4}</Data>
            <Data>{props.data4result}</Data>
          </DataContainer>
          <DataContainer>
            <Data>{props.dataName5}</Data>
            <Data>{props.data5result}</Data>
          </DataContainer>
        </DataList>
        <GraphicName>{props.graphicName}</GraphicName>
        <GraphicContainer>{props.graphic}</GraphicContainer>
      </Card>
    </div>
  );
}

CustomCardCharts.propTypes = {
  cardTitle: PropTypes.string,
  dataName1: PropTypes.string,
  data1result: PropTypes.string,
  dataName2: PropTypes.string,
  data2result: PropTypes.string,
  dataName3: PropTypes.string,
  data3result: PropTypes.string,
  dataName4: PropTypes.string,
  data4result: PropTypes.string,
  dataName5: PropTypes.string,
  data5result: PropTypes.string,
};

export default CustomCardCharts;
